import { ArtifactAssociationModel } from "./artifact-association-model";
import { ArtifactModel } from "./artifact-model";

export class ArtifactConnectionModel {
    artifactId: string;
    artifactType: string;
    artifactName: string;
    suites: { [key: string]: ArtifactModel };
    features: { [key: string]: ArtifactModel };
    scenarios: { [key: string]: ArtifactModel };
    steps: { [key: string]: ArtifactModel };
    artifactAssociations: ArtifactAssociationModel[];
}